import { jsxs as d, jsx as r } from "react/jsx-runtime";
import { useRef as p } from "react";
import f from "react-hot-toast";
import { CloseIcon as g } from "../../../icons/close-icon.mjs";
import { twMerge as e } from "tailwind-merge";
import { getBorderColor as x, getCloseIconColors as u } from "../utils/get-colors-by-type.mjs";
const N = ({
  t: o,
  afterClose: t,
  className: s,
  titleClassName: i,
  buttonClassName: a,
  hideCloseButton: n
}) => {
  const l = p(null), m = x(o.type), c = u(o.type);
  return /* @__PURE__ */ d(
    "div",
    {
      className: e(
        "bg-background-secondary text-text-tertiary flex max-w-[350px] items-center gap-2.5 rounded-lg border px-2.5 py-2 shadow-lg",
        o.visible ? "animate-toast-enter" : "animate-toast-leave",
        m,
        s
      ),
      "data-test-id": `toast-${o.type}`,
      children: [
        o.icon,
        /* @__PURE__ */ r("div", { className: e("break-words", i), children: o.message }),
        !n && /* @__PURE__ */ r(
          "button",
          {
            ref: l,
            className: e("group h-fit outline-hidden", a),
            onClick: () => {
              f.dismiss(o.id), t && t();
            },
            children: /* @__PURE__ */ r(
              g,
              {
                className: e("fill-fill-primary main-transition-colors", c)
              }
            )
          }
        )
      ]
    }
  );
};
export {
  N as ToastContainer
};
